import Input from "../../input/Input";
import TextArea from "../../textarea/TextArea";
import PropTypes from "prop-types";
import { getDate, getDateString } from "../../../../utils/date";
import './LunchInfoCreator.scss';

const LunchInfoCreator = ({
                              title,
                              setTitle,
                              description,
                              setDescription,
                              company,
                              setCompany,
                              companyUrl,
                              setCompanyUrl,
                              endDate,
                              setEndDate
                          }) => {
    const handleValidateField = (_, value) => !!value;
    const handleEndDate = (endDate) => {
        setEndDate(getDate(endDate));
    }
    return (
        <div className="lunch-info-creator">
            <Input
                id="title"
                name="title"
                value={title}
                onChange={setTitle}
                onValidate={handleValidateField}
                placeholder="Title"
            />
            <TextArea
                id={"lunch-menu-description"}
                name="description"
                value={description}
                onChange={setDescription}
                onValidate={handleValidateField}
                placeholder="Description..."
                label="Description"
            />
            <Input
                id="company"
                name="company"
                value={company}
                onChange={setCompany}
                onValidate={handleValidateField}
                placeholder="Name of the place"
            />
            <Input
                id="companyUrl"
                name="companyUrl"
                value={companyUrl}
                onChange={setCompanyUrl}
                onValidate={handleValidateField}
                placeholder="Link"
            />
            <Input
                id="endDate"
                name="endDate"
                type="datetime-local"
                value={getDateString(endDate)}
                onChange={handleEndDate}
                onValidate={handleValidateField}
                placeholder="Deadline date (DD-MM-YYYY HH:MM)"
            />
        </div>
    )
};

LunchInfoCreator.propTypes = {
    title: PropTypes.string,
    setTitle: PropTypes.func.isRequired,
    description: PropTypes.string,
    setDescription: PropTypes.func.isRequired,
    company: PropTypes.string,
    setCompany: PropTypes.func.isRequired,
    companyUrl: PropTypes.string,
    setCompanyUrl: PropTypes.func.isRequired,
    endDate: PropTypes.object,
    setEndDate: PropTypes.func.isRequired
}

export default LunchInfoCreator;
